export default __webpack_public_path__ + "static/media/Frame 176 (1).31a81fd6.svg";